import SuspendedProductTable from './suspendedProductTable.component';

export default SuspendedProductTable;